<div class="wrapper-select-filter-near-you">
  <div (click)="selectTheme(0)" class="wrapper-filter-box" [ngClass]="{'checked': selectedTheme === 0}">
    <span>
      {{'NEAR_YOU_PAGE.show_all' | translate}}
    </span>
    <img class="icon-check" src="../../../../../assets/icons/outline/icon-check.svg" alt="">
  </div>
</div>
<div class="grid">
  <div *ngFor="let theme of themes" (click)="selectTheme(theme.id)" class="grid__m-6" [ngClass]="{'checked': selectTheme === theme.id}">
    <div class="wrapper-card-theme" [style.background-color]="theme?.color">
      <div class="wrapper-theme-info">
        <span>{{theme.name}}</span>
      </div>
      <img class="icon-bg" [src]="theme.image_url !== null ? theme.image_url : 'assets/images/no-image.png'" alt="">
      <img class="icon-check" src="../../../../../assets/icons/outline/icon-check.svg" alt="">
    </div>
  </div>
</div>
